import { t } from '@lingui/core/macro';
import { useMutation } from '@tanstack/react-query';

import { usersControllerUploadFilesFormData } from '@/api/core-api';
import { notify } from '@/components/base/notifications/notifications';
import { getClient } from '@/utils/get-api-client';

export function useUploadProfilePicture() {
  return useMutation({
    mutationFn: async ({ file, userId }: { file: File; userId: string }) => {
      const formData = new FormData();
      formData.append('files', file, file.name);

      const response = await usersControllerUploadFilesFormData({
        client: getClient(userId),
        path: { userId },
        query: { type: 'picture' },
        // FormData requires bypassing the generated types and default JSON serializer
        body: formData as never,
        bodySerializer: null,
      });

      if (response.error) {
        throw new Error(t`Failed to upload profile picture`);
      }

      return response.data;
    },
    onSuccess: () => {
      notify({
        title: t`Profile picture uploaded`,
        color: 'success',
      });
    },
  });
}
